import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = {
  key: 1,
  class: "weather-modal__wrapper"
}
const _hoisted_3 = { class: "weather-modal__current-weather current-weather" }
const _hoisted_4 = { class: "current-weather__icon-row" }
const _hoisted_5 = { class: "current-weather__temperature" }
const _hoisted_6 = { class: "weather-modal__weather-details" }
const _hoisted_7 = { class: "weather-modal__icon-data" }
const _hoisted_8 = { class: "weather-modal__icon-data-value" }
const _hoisted_9 = { class: "weather-modal__icon-data" }
const _hoisted_10 = { class: "weather-modal__icon-data-value" }
const _hoisted_11 = { class: "weather-modal__icon-data" }
const _hoisted_12 = { class: "weather-modal__icon-data-value" }
const _hoisted_13 = { class: "weather-modal__icon-data" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { class: "weather-modal__icon-data-icon" }
const _hoisted_16 = { class: "weather-modal__icon-data-value" }
const _hoisted_17 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.descriptionTop)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "weather-modal__description",
          innerHTML: _ctx.descriptionTop
        }, null, 8, _hoisted_1))
      : _createCommentVNode("", true),
    (_ctx.staticParams.WEATHER_STATIONS_VIEW_ENABLE)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.formatWithUnit(_ctx.currentWeather?.tempAir, 'ºC', 1)), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _cache[0] || (_cache[0] = _createElementVNode("div", { class: "weather-modal__icon-data-icon" }, [
                _createElementVNode("i", { class: "icomoon-meteo-humidity" })
              ], -1)),
              _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.formatWithUnit(_ctx.currentWeather?.humidity, '% RH', 1)), 1)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _cache[1] || (_cache[1] = _createElementVNode("div", { class: "weather-modal__icon-data-icon" }, [
                _createElementVNode("i", { class: "icomoon-meteo-pressure" })
              ], -1)),
              _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.formatWithUnit(_ctx.currentWeather?.pressure, 'hPa', 1)), 1)
            ]),
            _createElementVNode("div", _hoisted_11, [
              _cache[2] || (_cache[2] = _createElementVNode("div", { class: "weather-modal__icon-data-icon" }, [
                _createElementVNode("i", { class: "icomoon-meteo-heavy-wind" })
              ], -1)),
              _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.formatWithUnit(_ctx.currentWeather?.windSpeed, 'm/s', 1)), 1)
            ]),
            _createElementVNode("div", _hoisted_13, [
              (_ctx.currentWeather && _ctx.currentWeather.windDeg !== null)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("i", {
                        class: _normalizeClass(
                  _ctx.currentWeather && _ctx.currentWeather.windDeg !== null
                  ? _ctx.directionToIconMapper(_ctx.direction(_ctx.currentWeather.windDeg))
                  : ''
                  )
                      }, null, 2)
                    ]),
                    _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.currentWeather && _ctx.currentWeather.windDeg !== null
                ? _ctx.direction(_ctx.currentWeather.windDeg)
                : ''), 1)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_17, "--"))
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}